/**
 * 题目 api
 * 题目 api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import DrillSectionVo from './DrillSectionVo';




  /**
   * The DrillAnswerSheetVo model module.
   * @module drill/model/DrillAnswerSheetVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>DrillAnswerSheetVo</code>.
   * @alias module:drill/model/DrillAnswerSheetVo
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>DrillAnswerSheetVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:drill/model/DrillAnswerSheetVo} obj Optional instance to populate.
   * @return {module:drill/model/DrillAnswerSheetVo} The populated <code>DrillAnswerSheetVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'courseStandardId')) {
        obj['courseStandardId'] = ApiClient.convertToType(data['courseStandardId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'knowledgeId')) {
        obj['knowledgeId'] = ApiClient.convertToType(data['knowledgeId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'textbookId')) {
        obj['textbookId'] = ApiClient.convertToType(data['textbookId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'unitId')) {
        obj['unitId'] = ApiClient.convertToType(data['unitId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'lessonId')) {
        obj['lessonId'] = ApiClient.convertToType(data['lessonId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'sectionId')) {
        obj['sectionId'] = ApiClient.convertToType(data['sectionId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'sessionTime')) {
        obj['sessionTime'] = ApiClient.convertToType(data['sessionTime'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'isNewSession')) {
        obj['isNewSession'] = ApiClient.convertToType(data['isNewSession'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'sectionList')) {
        obj['sectionList'] = ApiClient.convertToType(data['sectionList'], [DrillSectionVo]);
      }
    }
    return obj;
  }

  /**
   * courseStandardId
   * @member {Integer} courseStandardId
   */
  exports.prototype['courseStandardId'] = undefined;
  /**
   * 知识点id
   * @member {Integer} knowledgeId
   */
  exports.prototype['knowledgeId'] = undefined;
  /**
   * 云教材id
   * @member {Integer} textbookId
   */
  exports.prototype['textbookId'] = undefined;
  /**
   * unitId id
   * @member {Integer} unitId
   */
  exports.prototype['unitId'] = undefined;
  /**
   * lesson id
   * @member {Integer} lessonId
   */
  exports.prototype['lessonId'] = undefined;
  /**
   * section id
   * @member {Integer} sectionId
   */
  exports.prototype['sectionId'] = undefined;
  /**
   * 会话开始时间
   * @member {Integer} sessionTime
   */
  exports.prototype['sessionTime'] = undefined;
  /**
   * 是否是新会话
   * @member {Boolean} isNewSession
   */
  exports.prototype['isNewSession'] = undefined;
  /**
   * 小节列表
   * @member {Array.<module:drill/model/DrillSectionVo>} sectionList
   */
  exports.prototype['sectionList'] = undefined;



  export default exports;
;


